

<script>
import Vue from 'vue';
export default Vue.component('pcr-grant-level-label', {
    props: {
        item: {
            default: ''
        },
        grantLevel: {
            default: ''
        },
        isExplicit: {
            type: Boolean,
            default: false
        },
        removeIcons: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            templateRender: null,
        };
    },
    render(h) {
        if (!this.templateRender) {
            return h('div', 'loading...');
        } else { // If there is a template, I'll show it
            return this.templateRender();
        }
    },
    methods: {
        getGrantLevelLabel(item) {
            if (!item) {
                item = {
                    GrantLevel: this.grantLevel,
                    IsExplicit: this.isExplicit
                }
            }

            let result = '';
            if (!this.removeIcons) {
                if (item.IsTemporary)
                    result += `<el-tooltip placement="top" content="Autorisation spécifique temporaire: ${this.GrantLevelNames[item.TemporaryGrantLevel]}" effect="light" :open-delay="300">`;
                else if (item.IsExplicit)
                    result += `<el-tooltip placement="top" content="Autorisation spécifique: ${this.GrantLevelNames[item.PermanentGrantLevel]}" effect="light" :open-delay="300">`;
                else
                    result += `<el-tooltip placement="top" content="Autorisation héritée" effect="light" :open-delay="300">`;
            }

            if (item.GrantLevel == 0) {
                result += `<span class="label label-inverse">Aucune ${this.getIcons(item)}</span>`;
            }
            if (item.GrantLevel == 8) {
                result += `<span class="label label-success">Contact ${this.getIcons(item)}</span>`;
            }
            if (item.GrantLevel == 16) {
                result += `<span class="label label-primary">Viewer ${this.getIcons(item)}</span>`;
            }
            if (item.GrantLevel == 64) {
                result += `<span class="label label-info">Editeur ${this.getIcons(item)}</span>`;
            }
            if (item.GrantLevel == 112) {
                result += `<span class="label label-warning">Administrateur ${this.getIcons(item)}</span>`;
            }
            if (item.GrantLevel == 127) {
                if(this.$user.IsSysAdmin) {
                    result += `<span class="label label-important">Super administrateur ${this.getIcons(item)}</span>`;
                }
                else {
                    result += `<span class="label label-warning">Administrateur ${this.getIcons(item)}</span>`;
                }
            }

            if (!this.removeIcons) {
                result += `</el-tooltip>`;
            }

            return result;
        },
        getIcons(item) {
            if (this.removeIcons) return '';

            let result = ' ';
            if (item.IsTemporary){
                let endDate = new Date(parseInt(item.EndDate.replace("/Date(", "").replace(")/", ""), 10));
                result += '<i class="fa fa-clock-o" aria-hidden="true"></i> ' + this.formattedDate(endDate);
            }
            else if (item.IsExplicit)
                result += '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';

            return result;
        },
        formattedDate(d) {
            let month = String(d.getMonth() + 1);
            let day = String(d.getDate());
            const year = String(d.getFullYear());

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return `${day}/${month}/${year}`;
        }
    },

    watch: {
        // Every time the template prop changes, I recompile it to update the DOM
        item: {
            immediate: true, // makes the watcher fire on first render, too.
            handler() {
                var res = Vue.compile(this.getGrantLevelLabel(this.item));

                this.templateRender = res.render;
            }
        },
        grantLevel: {
            immediate: true, // makes the watcher fire on first render, too.
            handler() {
                var res = Vue.compile(this.getGrantLevelLabel(this.item));

                this.templateRender = res.render;
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/visual/pcr-grant-level-label.vue